export interface AuditState {
  totalTestsToRun: number
  currentTestsRan: number
  testIds: string[]
  tests: AuditTableEntry[]
  percentage: number
  inProgress: boolean
}

export const initialState = {
  totalTestsToRun: 0,
  currentTestsRan: 0,
  testIds: [],
  tests: [],
  percentage: 0,
  inProgress: false,
}

export const audit = (
  state: AuditState = initialState,
  action: ReduxAction,
): AuditState => {
  switch (action.type) {
    case 'UPDATE_AUDIT_DATA':
      return {
        ...state,
        ...action.payload,
        inProgress:
          action.payload?.currentTestsRan !== action.payload?.totalTestsToRun,
        testIds: [
          ...new Set([
            ...state.testIds,
            ...action.payload.tests.map(
              ({ testid }: { testid: string }): string => testid,
            ),
          ]),
        ],
        tests: [
          ...state.tests,
          ...action.payload.tests.filter(
            ({ testid }: { testid: string }): any =>
              !state.testIds.includes(testid),
          ),
        ],
      }
    case 'CLEAR_AUDIT_DATA':
      return { ...initialState, inProgress: true }
    default:
      return state
  }
}
